import React, { useEffect, useState } from "react";
import api from "../api";
import { Col, Container, Row } from "shards-react";
import {
  CircularProgress,
  createMuiTheme,
  MuiThemeProvider
} from "@material-ui/core";
import MUIDataTable from "mui-datatables";
import axios from "axios";
import { useParams } from "react-router-dom";
import PageTitle from "../../common/PageTitle";

const getMuiTheme = () =>
  createMuiTheme({
    overrides: {
      MuiTableCell: {
        root: {
          padding: "0px 8px 0px 8px",
          fontSize: "0.73rem"
        }
      },
      MuiFormLabel: {
        root: {
          fontSize: "0.75rem"
        }
      },
      MuiInputBase: {
        root: {
          fontSize: "0.75rem"
        }
      },
      MuiTypography: {
        body1: {
          fontSize: "0.75rem"
        }
      }
    }
  });

export const getColumns = () => [
  {
    name: "date",
    label: "Fecha",
    options: {
      filter: false,
      sort: true,
      display: true
    }
  },
  {
    name: "time",
    label: "Hora",
    options: {
      filter: false,
      sort: true,
      display: true
    }
  },
  {
    name: "station",
    label: "Estación",
    options: {
      filter: false,
      sort: true,
      display: true
    }
  },
  {
    name: "device",
    label: "Dispositivo",
    options: {
      filter: false,
      sort: true,
      display: true
    }
  },
  {
    name: "category",
    label: "Categoría",
    options: {
      filter: false,
      sort: true,
      display: true
    }
  },
  {
    name: "amount",
    label: "Importe",
    options: {
      filter: false,
      sort: true,
      display: true,
      customBodyRender: value => {
        if (value === null || value === undefined || value === "") return "";
        const amount = Number(value);
        return Number.isNaN(amount) ? value : `$${amount.toFixed(2)}`;
      }
    }
  }
];

const BookingTelepaseToll = ({id}) => {
  const [booking, setBooking] = useState(null);
  const [loading, setLoading] = useState(true);
  const getBooking = async (bookingId) => {
    const token = localStorage.getItem("userToken");
    var url = api.bookings().get(bookingId);
    return await axios
      .get(url, {
        headers: { Authorization: `Bearer ${token}` }
      })
  };
  useEffect(() => {
    const getBookingEffect = async () => {
      const booking = await getBooking(id);
      setBooking(booking.data   );
      setLoading(false);
    };
    getBookingEffect();
  }, []);

  const handleDownloadExcel = async () => {
    const token = localStorage.getItem("userToken");
    var url = api.bookings().downloadTelepaseTolls(id);
    window.open(url, '_blank');
  };

  const options = {
    print: false,
    responsive: "stacked",
    selectableRowsOnClick: false,
    selectableRows: false,
    download: true,
    onDownload: () => {
      handleDownloadExcel();
      return false;
    },
    textLabels: {
      toolbar: {
        search: "Buscar",
        viewColumns: "Ver columnas",
        filterTable: "Filtros",
        downloadCsv: "Exportar XLS"
      },
      body: {
        noMatch: loading ? "No hay resultados" : <CircularProgress />
      },
      selectedRows: {
        text: "fila(s) seleccionadas"
      },
      viewColumns: {
        title: "Ver columnas"
      },
      pagination: {
        next: "Siguiente",
        previous: "Anteior",
        rowsPerPage: "Cantidad por página:",
        displayRows: "de"
      },
      filter: {
        all: "Todos",
        title: "Filtros",
        reset: "Limpiar"
      }
    },
  };

  return (
    <div>
      {loading ? (
        <div>
          <CircularProgress />
        </div>
      ) : (
        <Container fluid className="main-content-container px-4">
          <Row>
            <Col className="p-2">
              <div>
                <MuiThemeProvider theme={getMuiTheme()}>
                  <MUIDataTable
                    title={`Lista de Pasajes Telepase de la reserva ${booking.id} - ${booking.client.business_name}`}
                    data={booking.telepase_tolls}
                    columns={getColumns()}
                    options={options}
                  />
                </MuiThemeProvider>
              </div>
            </Col>
          </Row>
        </Container>
      )}
    </div>
  );
};
export default BookingTelepaseToll;

